// HomePage.tsx (React SPA)
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Expertise from '../components/Expertise';

const HomePage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // keep if you'll add the header
  const navigate = useNavigate();

  return (
    <>
      <div className="bg-gray-100 min-h-[800px]">
        <div className="relative isolate px-6 pt-14 lg:px-8">
          {/* Top blob */}
          {/* <div aria-hidden="true" className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80">
            <div
              style={{
                clipPath:
                  'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
              }}
              className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem]
                         -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr
                         from-[#f3eef2] to-[#e6e5f3] opacity-30
                         sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            />
          </div> */}

          <div className="mx-auto max-w-4xl py-22 sm:py-48 lg:py-36">
            <div className="hidden sm:mb-8 sm:flex sm:justify-center">
              <div className="relative rounded-full px-3 py-1 text-sm/6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                <a href="/blog" className="font-semibold text-indigo-600 underline-offset-4 hover:underline">
                  <span aria-hidden="true" className="absolute inset-0" />
                  Read more <span aria-hidden="true">→</span>
                </a>
              </div>
            </div>

            <div className="text-left">
              <h1 className="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-6xl">
                Hi I&apos;m <span className="text-blue-800">Angelo Ruiz</span>
              </h1>

              <p className="mt-2 text-pretty text-md font-medium text-gray-500">
                I’m a certified IT professional with 20+ years in systems administration,
                networking, and software development—specializing in automation and secure, scalable solutions.
                My goal is to streamline operations and empower teams to work smarter.
              </p>

              <p className="mt-2 text-pretty text-md font-semibold text-black bg-gray-100 p-2 rounded-md border border-gray-300 mt-9">
                + Co-founder of{' '}
                <a href="https://arincentive.com" className="text-indigo-600 hover:underline">
                  Aileron Systems
                </a>
                , building AI-driven automation incentives for businesses.
              </p>

              <div className="mt-10 flex flex-col sm:flex-row items-center sm:justify-center gap-4">
                <button
                  type="button"
                  aria-label="Hire me"
                  className="rounded-md bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  onClick={() => navigate('/contact')}
                >
                  Hire Me <span aria-hidden="true">→</span>
                </button>

                <a
                  href="https://www.linkedin.com/in/arcode/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Open LinkedIn profile"
                  className="font-extrabold text-blue-700 hover:underline underline-offset-4 text-sm"
                >
                  Follow me <br/>LinkedIn <span aria-hidden="true">→</span>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom blob */}
          {/* <div aria-hidden="true" className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
            <div
              style={{
                clipPath:
                  'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
              }}
              className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem]
                         -translate-x-1/2 bg-gradient-to-tr from-[#edebec]
                         to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)]
                         sm:w-[72.1875rem]"
            />
          </div> */}

        </div>
      </div>
      {/* Expertise */}
      <Expertise title="Expertise" />
    </>
  );
};

export default HomePage;
